import request from './axios'

export function getNews () {
  return request({
    url: 'http://localhost:3001/mock/news',
    method: 'get'
  })
}
export function anonymousLogin () {
  return request({
    url: '/api/blade-auth/anonymousLogin',
    method: 'post'
  })
}
